export default function (context) {
	const currency = context.$cookie.get('currency_type')
	if (parseInt(currency) === 2) {
		return context.redirect('/');
	}
}